<template>
  <div class="settle-audit-container">
    <el-card class="list-wrapper">
      <div slot="header" class="flex justify-between" style="align-items: center">
        <span>{{ $t('auditSettle.listTitle') }}</span>
      </div>

      <!-- 筛选栏 -->
      <div class="filter-wrapper">
        <div class="filter-left">
          <el-form :inline="true" size="small">
            <el-form-item :label="$t('auditSettle.filter.timeLabel')">
              <el-date-picker
                v-model="filter.timeRange"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('auditSettle.filter.startPlaceholder')"
                :end-placeholder="$t('auditSettle.filter.endPlaceholder')"
                value-format="yyyy-MM-dd"
                style="width: 250px"
              />
            </el-form-item>
            <el-form-item :label="$t('auditSettle.auditStatus')">
              <el-select v-model="filter.auditStatus" :placeholder="$t('auditSettle.filter.all')" clearable style="width: 120px">
                <el-option v-for="(label, key) in $t('auditSettle.auditStatusMap')" :key="key" :label="label" :value="key" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('auditSettle.arriveStatus')">
              <el-select v-model="filter.arriveStatus" :placeholder="$t('auditSettle.filter.all')" clearable style="width: 120px">
                <el-option v-for="(label, key) in $t('auditSettle.arriveStatusMap')" :key="key" :label="label" :value="key" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('auditSettle.settleType')">
              <el-select v-model="filter.settleType" :placeholder="$t('auditSettle.filter.all')" clearable style="width: 130px">
                <el-option :label="$t('auditSettle.settleTypeMap.internal')" value="0" />
                <el-option :label="$t('auditSettle.settleTypeMap.bank')" value="1" />
              </el-select>
            </el-form-item>
            <el-form-item :label="$t('auditSettle.storeName')">
              <el-input v-model="filter.storeName" :placeholder="$t('auditSettle.filter.storeNamePlaceholder')" clearable style="width: 150px" />
            </el-form-item>
            <el-form-item :label="$t('auditSettle.settleNo')">
              <el-input
                v-model="filter.settleNo"
                :placeholder="$t('auditSettle.filter.settleNoPlaceholder')"
                clearable
                style="width: 160px"
                @keyup.enter.native="handleSearch"
              />
            </el-form-item>
          </el-form>
        </div>
        <div class="filter-right">
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">{{ $t('auditSettle.filter.search') }}</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">{{ $t('auditSettle.filter.reset') }}</el-button>
        </div>
      </div>

      <el-table v-loading="loading" :data="tableData" border style="width: 100%">
        <el-table-column prop="settleNo" :label="$t('auditSettle.settleNo')" align="center" min-width="150" />
        <el-table-column prop="storeName" :label="$t('auditSettle.storeName')" align="center" min-width="150">
          <template slot-scope="scope">
            {{ scope.row.storeName || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="amount" :label="$t('auditSettle.amount')" align="center" width="120">
          <template slot-scope="scope">
            {{ Number(scope.row.amount || 0).toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('auditSettle.settleType')" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="scope.row.settleType === '0' ? 'info' : 'warning'" size="small">
              {{ scope.row.settleType === '0' ? $t('auditSettle.settleTypeMap.internal') : $t('auditSettle.settleTypeMap.bank') }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('auditSettle.bankFee')" align="center" width="120">
          <template slot-scope="scope">
            <span style="color: #e6a23c">{{ Number(scope.row.bankFee || 0).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('auditSettle.platformPay')" align="center" width="120">
          <template slot-scope="scope">
            <span style="color: #409eff; font-weight: bold">¥ {{ Number(scope.row.settleAmount || 0).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('auditSettle.auditStatus')" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="$t('auditSettle.auditTag')[scope.row.auditStatus] || 'info'">
              {{ $t('auditSettle.auditStatusMap')[scope.row.auditStatus] || scope.row.auditStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column :label="$t('auditSettle.arriveStatus')" align="center" width="100">
          <template slot-scope="scope">
            <el-tag :type="$t('auditSettle.arriveTag')[scope.row.arriveStatus] || 'info'">
              {{ $t('auditSettle.arriveStatusMap')[scope.row.arriveStatus] || scope.row.arriveStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="applyTime" :label="$t('auditSettle.applyTime')" align="center" width="160" />
        <el-table-column prop="auditTime" :label="$t('auditSettle.auditTime')" align="center" width="160">
          <template slot-scope="scope">{{ scope.row.auditTime || '-' }}</template>
        </el-table-column>
        <el-table-column prop="arriveTime" :label="$t('auditSettle.arriveTime')" align="center" width="160">
          <template slot-scope="scope">{{ scope.row.arriveTime || '-' }}</template>
        </el-table-column>
        <el-table-column :label="$t('auditSettle.operation')" align="center" width="220" fixed="right">
          <template slot-scope="scope">
            <template v-if="scope.row.auditStatus === '0'">
              <el-button type="text" size="small" style="color: #67c23a" @click="handlePass(scope.row)">
                {{ $t('auditSettle.btn.pass') }}
              </el-button>
              <el-button type="text" size="small" style="color: #f56c6c" @click="handleReject(scope.row)">
                {{ $t('auditSettle.btn.reject') }}
              </el-button>
            </template>
            <el-button
              v-if="scope.row.auditStatus === '1' && scope.row.arriveStatus !== '1'"
              type="text"
              size="small"
              style="color: #409eff"
              @click="handleArrive(scope.row)"
            >
              {{ $t('auditSettle.btn.arrive') }}
            </el-button>
            <el-button type="text" size="small" @click="handleDetail(scope.row)">
              {{ $t('auditSettle.btn.detail') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="pagination-wrapper">
        <div class="pager-right" style="margin-left: auto">
          <el-pagination
            background
            layout="total, prev, pager, next, jumper"
            :total="total"
            :current-page.sync="currentPage"
            :page-size="pageSize"
            @current-change="handlePageChange"
          />
        </div>
      </div>
    </el-card>

    <!-- 审核弹窗（通过/驳回，填平台备注） -->
    <el-dialog custom-class="audit-dialog" :title="auditDialog.title" :visible.sync="auditDialogVisible" width="460px" :close-on-click-modal="false">
      <el-alert
        :title="auditDialog.tip"
        :type="auditDialog.auditStatus === '1' ? 'success' : 'warning'"
        :closable="false"
        style="margin-bottom: 12px"
      />
      <div class="audit-summary">
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.settleNo') }}：</span>{{ auditDialog.row.settleNo || '-' }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.storeName') }}：</span>{{ auditDialog.row.storeName || '-' }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.settleType') }}：</span>
          <el-tag :type="auditDialog.row.settleType === '0' ? 'info' : 'warning'" size="mini">
            {{ auditDialog.row.settleType === '0' ? $t('auditSettle.settleTypeMap.internal') : $t('auditSettle.settleTypeMap.bank') }}
          </el-tag>
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.amount') }}：</span>
          <span style="color: #e6a23c; font-weight: bold">¥ {{ Number(auditDialog.row.amount || 0).toFixed(2) }}</span>
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.bankFee') }}：</span>¥ {{ Number(auditDialog.row.bankFee || 0).toFixed(2) }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.platformPay') }}：</span>
          <span style="color: #409eff; font-weight: bold">¥ {{ Number(auditDialog.row.settleAmount || 0).toFixed(2) }}</span>
        </div>
        <div class="audit-row audit-divider">{{ $t('auditSettle.ownerName') }}（{{ $t('auditSettle.storeName') }}{{ $t('auditSettle.dialog.invoiceInfo') }}）</div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.ownerName') }}：</span>{{ auditDialog.row.ownerName || '-' }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.bankName') }}：</span>{{ auditDialog.row.bankName || '-' }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.bankCard') }}：</span>{{ auditDialog.row.bankCard || '-' }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.bankAddress') }}：</span>{{ auditDialog.row.bankAddress || '-' }}
        </div>
      </div>
      <el-form :model="auditDialog.form" label-width="90px" style="margin-top: 8px">
        <el-form-item :label="$t('auditSettle.platformRemark')">
          <el-input v-model="auditDialog.form.platformRemark" type="textarea" :rows="2" :placeholder="$t('auditSettle.dialog.remarkPlaceholder')" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="auditDialogVisible = false">{{ $t('auditSettle.dialog.cancel') }}</el-button>
        <el-button type="primary" :loading="auditing" @click="submitAudit">{{ $t('auditSettle.dialog.confirm') }}</el-button>
      </div>
    </el-dialog>

    <!-- 到账确认 -->
    <el-dialog custom-class="arrive-dialog" :title="$t('auditSettle.dialog.arriveTitle')" :visible.sync="arriveConfirmVisible" width="460px" :close-on-click-modal="false">
      <el-alert :title="$t('auditSettle.dialog.arriveConfirm')" type="info" :closable="false" style="margin-bottom: 12px" />
      <div class="audit-summary">
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.settleNo') }}：</span>{{ arriveRow.settleNo || '-' }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.storeName') }}：</span>{{ arriveRow.storeName || '-' }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.settleType') }}：</span>
          <el-tag :type="arriveRow.settleType === '0' ? 'info' : 'warning'" size="mini">
            {{ arriveRow.settleType === '0' ? $t('auditSettle.settleTypeMap.internal') : $t('auditSettle.settleTypeMap.bank') }}
          </el-tag>
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.amount') }}：</span>
          <span style="color: #e6a23c; font-weight: bold">¥ {{ Number(arriveRow.amount || 0).toFixed(2) }}</span>
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.bankFee') }}：</span>¥ {{ Number(arriveRow.bankFee || 0).toFixed(2) }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.platformPay') }}：</span>
          <span style="color: #409eff; font-weight: bold">¥ {{ Number(arriveRow.settleAmount || 0).toFixed(2) }}</span>
        </div>
        <div class="audit-row audit-divider">{{ $t('auditSettle.ownerName') }}（{{ $t('auditSettle.storeName') }}{{ $t('auditSettle.dialog.invoiceInfo') }}）</div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.ownerName') }}：</span>{{ arriveRow.ownerName || '-' }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.bankName') }}：</span>{{ arriveRow.bankName || '-' }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.bankCard') }}：</span>{{ arriveRow.bankCard || '-' }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.bankAddress') }}：</span>{{ arriveRow.bankAddress || '-' }}
        </div>
        <div class="audit-row">
          <span class="audit-label">{{ $t('auditSettle.applyRemark') }}：</span>{{ arriveRow.applyRemark || '-' }}
        </div>
      </div>
      <div class="voucher-block">
        <div class="voucher-label">
          {{ $t('auditSettle.voucher') }}
          <span v-if="arriveRow.settleType === '1'" class="voucher-required">*</span>
          <span v-if="arriveRow.settleType === '1'" class="voucher-required-tip">{{ $t('auditSettle.dialog.voucherRequired') }}</span>
        </div>
        <div class="voucher-tip">{{ $t('auditSettle.dialog.voucherTip') }}</div>
        <div class="voucher-uploader">
          <div v-if="arriveVoucherUrl" class="voucher-preview">
            <el-image
              style="width: 100px; height: 100px; border-radius: 4px"
              :src="arriveVoucherUrl"
              fit="cover"
              :preview-src-list="[arriveVoucherUrl]"
              @error="handleVoucherRenderError"
            />
            <i class="el-icon-delete voucher-delete" @click="arriveVoucherUrl = ''"></i>
          </div>
          <div v-else class="voucher-upload-btn" @click="$refs.voucherFileInput.click()">
            <i class="el-icon-plus"></i>
          </div>
          <input ref="voucherFileInput" type="file" accept="image/*" hidden @change="handleVoucherFileChange" />
        </div>
      </div>
      <div slot="footer">
        <el-button @click="arriveConfirmVisible = false">{{ $t('auditSettle.dialog.cancel') }}</el-button>
        <el-button type="primary" :loading="arriving" @click="submitArrive">{{ $t('auditSettle.dialog.confirm') }}</el-button>
      </div>
    </el-dialog>

    <!-- 结算单详情 -->
    <el-dialog custom-class="detail-dialog" :title="$t('auditSettle.dialog.detailTitle')" :visible.sync="detailVisible" width="560px" :close-on-click-modal="false">
      <div class="detail-box">
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.settleNo') }}</span><span>{{ detailRow.settleNo || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.storeName') }}</span><span>{{ detailRow.storeName || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.amount') }}</span><span>¥ {{ Number(detailRow.amount || 0).toFixed(2) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.settleType') }}</span>
          <span>{{ detailRow.settleType === '0' ? $t('auditSettle.settleTypeMap.internal') : $t('auditSettle.settleTypeMap.bank') }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.ownerName') }}</span><span>{{ detailRow.ownerName || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.bankName') }}</span><span>{{ detailRow.bankName || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.bankCard') }}</span><span>{{ detailRow.bankCard || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.bankAddress') }}</span><span>{{ detailRow.bankAddress || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.bankFee') }}</span><span>¥ {{ Number(detailRow.bankFee || 0).toFixed(2) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.platformFee') }}</span><span>¥ {{ Number(detailRow.platformFee || 0).toFixed(2) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.dialog.settleAmount') }}</span><span>¥ {{ Number(detailRow.settleAmount || 0).toFixed(2) }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.applyRemark') }}</span><span>{{ detailRow.applyRemark || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.auditStatus') }}</span>
          <span>{{ $t('auditSettle.auditStatusMap')[detailRow.auditStatus] || detailRow.auditStatus }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.auditUser') }}</span><span>{{ detailRow.auditUser || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.auditTime') }}</span><span>{{ detailRow.auditTime || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.arriveStatus') }}</span>
          <span>{{ $t('auditSettle.arriveStatusMap')[detailRow.arriveStatus] || detailRow.arriveStatus }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.arriveTime') }}</span><span>{{ detailRow.arriveTime || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.voucher') }}</span>
          <span v-if="detailRow.voucherUrl">
            <el-image
              style="width: 90px; height: 90px; border-radius: 4px; margin: 4px 0"
              :src="detailRow.voucherUrl"
              fit="cover"
              :preview-src-list="[detailRow.voucherUrl]"
            />
          </span>
          <span v-else>{{ $t('auditSettle.noVoucher') }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.platformRemark') }}</span><span>{{ detailRow.platformRemark || '-' }}</span>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ $t('auditSettle.applyTime') }}</span><span>{{ detailRow.applyTime || '-' }}</span>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="detailVisible = false">{{ $t('auditSettle.dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listAuditSettleOrders, auditSettle, arriveSettle } from '@/api/fee/settleApi'
import { uploadFile } from '@/api/staff/addStaffApi'
import { getCommunityId } from '@/api/community/communityApi'

export default {
  name: 'settleAuditList',
  data() {
    return {
      loading: false,
      auditing: false,
      arriving: false,
      tableData: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      filter: {
        settleNo: '',
        auditStatus: '',
        arriveStatus: '',
        settleType: '',
        storeName: '',
        timeRange: []
      },
      auditDialogVisible: false,
      auditDialog: {
        title: '',
        tip: '',
        auditStatus: '1',
        row: {},
        form: {
          platformRemark: ''
        }
      },
      arriveConfirmVisible: false,
      arriveRow: {},
      arriveVoucherUrl: '',
      detailVisible: false,
      detailRow: {}
    }
  },
  created() {
    this._loadData()
  },
  methods: {
    _loadData() {
      this.loading = true
      const params = {
        page: this.currentPage,
        row: this.pageSize
      }
      if (this.filter.settleNo) params.settleNo = this.filter.settleNo
      if (this.filter.auditStatus !== '') params.auditStatus = this.filter.auditStatus
      if (this.filter.arriveStatus !== '') params.arriveStatus = this.filter.arriveStatus
      if (this.filter.settleType !== '') params.settleType = this.filter.settleType
      if (this.filter.storeName) params.storeName = this.filter.storeName
      if (this.filter.timeRange && this.filter.timeRange.length === 2) {
        params.startTime = this.filter.timeRange[0] + ' 00:00:00'
        params.endTime = this.filter.timeRange[1] + ' 23:59:59'
      }
      listAuditSettleOrders(params).then(res => {
        this.loading = false
        if (res.code === 0) {
          this.tableData = res.data || []
          this.total = res.total || 0
        } else {
          this.$message.error(res.msg || '查询失败')
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSearch() {
      this.currentPage = 1
      this._loadData()
    },
    handleReset() {
      this.filter = {
        settleNo: '',
        auditStatus: '',
        arriveStatus: '',
        settleType: '',
        storeName: '',
        timeRange: []
      }
      this.currentPage = 1
      this._loadData()
    },
    handlePageChange() {
      this._loadData()
    },
    handlePass(row) {
      this.auditDialog = {
        title: this.$t('auditSettle.dialog.passTitle'),
        tip: this.$t('auditSettle.dialog.passConfirm'),
        auditStatus: '1',
        row,
        form: { platformRemark: '' }
      }
      this.auditDialogVisible = true
    },
    handleReject(row) {
      this.auditDialog = {
        title: this.$t('auditSettle.dialog.rejectTitle'),
        tip: this.$t('auditSettle.dialog.rejectConfirm'),
        auditStatus: '2',
        row,
        form: { platformRemark: '' }
      }
      this.auditDialogVisible = true
    },
    submitAudit() {
      this.auditing = true
      const data = {
        settleId: this.auditDialog.row.settleId,
        auditStatus: this.auditDialog.auditStatus,
        platformRemark: this.auditDialog.form.platformRemark || ''
      }
      auditSettle(data).then(res => {
        this.auditing = false
        if (res.code === 0) {
          this.$message.success(
            this.auditDialog.auditStatus === '1'
              ? this.$t('auditSettle.dialog.passSuccess')
              : this.$t('auditSettle.dialog.rejectSuccess')
          )
          this.auditDialogVisible = false
          this._loadData()
        } else {
          this.$message.error(res.msg || '审核失败')
        }
      }).catch(() => {
        this.auditing = false
      })
    },
    handleArrive(row) {
      this.arriveRow = row
      this.arriveVoucherUrl = row.voucherUrl || ''
      this.arriveConfirmVisible = true
    },
    handleVoucherRenderError() {
      this.$message.error(this.$t('auditSettle.dialog.voucherRenderFail'))
    },
    handleVoucherFileChange(event) {
      const file = event.target.files[0]
      if (!file) return
      const isImage = file.type.indexOf('image/') === 0
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isImage) {
        this.$message.error(this.$t('auditSettle.dialog.voucherTypeError'))
        event.target.value = null
        return
      }
      if (!isLt2M) {
        this.$message.error(this.$t('auditSettle.dialog.voucherSizeError'))
        event.target.value = null
        return
      }
      const formData = new FormData()
      formData.append('uploadFile', file)
      formData.append('communityId', getCommunityId())
      uploadFile(formData).then(res => {
        const url = (res && res.url) || (res && res.data && res.data.url) || ''
        if (url) {
          this.arriveVoucherUrl = url
          this.$message.success(this.$t('auditSettle.dialog.voucherUploadSuccess'))
        } else {
          this.$message.error(this.$t('auditSettle.dialog.voucherUploadFail'))
        }
      }).catch(() => {
        this.$message.error(this.$t('auditSettle.dialog.voucherUploadFail'))
      })
      event.target.value = null
    },
    submitArrive() {
      if (this.arriveRow.settleType === '1' && !this.arriveVoucherUrl) {
        this.$message.error(this.$t('auditSettle.dialog.voucherRequired'))
        return
      }
      this.arriving = true
      arriveSettle({
        settleId: this.arriveRow.settleId,
        voucherUrl: this.arriveVoucherUrl || ''
      }).then(res => {
        this.arriving = false
        if (res.code === 0) {
          this.$message.success(this.$t('auditSettle.dialog.arriveSuccess'))
          this.arriveConfirmVisible = false
          this._loadData()
        } else {
          this.$message.error(res.msg || '标记到账失败')
        }
      }).catch(() => {
        this.arriving = false
      })
    },
    handleDetail(row) {
      this.detailRow = row
      this.detailVisible = true
    }
  }
}
</script>

<style scoped>
/* 筛选栏：选项靠左、按钮靠右 */
.filter-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: 12px;
}
.filter-left {
  flex: 1;
  min-width: 0;
}
.filter-left /deep/ .el-form-item {
  margin-bottom: 0;
}
.filter-right {
  flex-shrink: 0;
  margin-left: 12px;
}
.pagination-wrapper {
  margin-top: 15px;
  display: flex;
  align-items: center;
}
/* 审核弹窗/详情弹窗内容靠左（全局 #app{text-align:center} 会继承） */
::v-deep .audit-dialog,
::v-deep .arrive-dialog,
::v-deep .detail-dialog {
  text-align: left;
}
.audit-summary {
  width: 100%;
  padding: 8px 12px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background: #fafafa;
  box-sizing: border-box;
}
.audit-row {
  font-size: 13px;
  line-height: 1.9;
  color: #606266;
  word-break: break-all;
}
.audit-label {
  color: #909399;
}
.audit-divider {
  margin: 4px 0 2px;
  padding: 4px 0;
  border-top: 1px solid #e4e7ed;
  font-weight: bold;
  color: #303133;
}
.voucher-block {
  margin-top: 12px;
  padding: 10px 12px;
  border: 1px dashed #dcdfe6;
  border-radius: 4px;
  background: #fafafa;
}
.voucher-label {
  font-size: 13px;
  color: #606266;
  font-weight: bold;
}
.voucher-required {
  color: #f56c6c;
  margin-left: 2px;
}
.voucher-required-tip {
  font-weight: normal;
  font-size: 12px;
  color: #f56c6c;
  margin-left: 6px;
}
.voucher-tip {
  font-size: 12px;
  color: #909399;
  margin: 4px 0 8px;
}
.voucher-uploader {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.voucher-preview {
  position: relative;
  display: inline-block;
  width: 100px;
  height: 100px;
}
.voucher-upload-btn {
  width: 100px;
  height: 100px;
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #909399;
  font-size: 24px;
  background: #fff;
  transition: border-color 0.2s, color 0.2s;
}
.voucher-upload-btn:hover {
  border-color: #409eff;
  color: #409eff;
}
.voucher-delete {
  position: absolute;
  top: -8px;
  right: -8px;
  color: #f56c6c;
  font-size: 18px;
  cursor: pointer;
  background: #fff;
  border-radius: 50%;
  padding: 2px;
  z-index: 1;
}
.detail-box {
  max-height: 60vh;
  overflow-y: auto;
}
.detail-row {
  display: flex;
  font-size: 13px;
  line-height: 2;
  color: #606266;
  word-break: break-all;
  border-bottom: 1px solid #f0f0f0;
}
.detail-label {
  width: 110px;
  flex-shrink: 0;
  color: #909399;
}
</style>
